module.exports = __webpack_public_path__ + "static/img/app-train-2.c75d07c2.png";